export const JSON_API_CONTENT_TYPE = 'application/vnd.api+json';
export const JSON_API_CONTENT_TYPE_HEADER = {
  'Content-Type': JSON_API_CONTENT_TYPE,
};
